export const getCookie = (name) => {
    const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return match ? decodeURIComponent(match[2]) : null;
};

export const setCookie = (name, value, opts = {}) => {
    const { days = 365, secure = true, sameSite = 'Lax' } = opts;
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; path=/; expires=${expires}; SameSite=${sameSite}${secure ? '; Secure' : ''}`;
};
